// @flow
import { get } from 'lodash';
import { resolve } from 'redux-optimist-promise';

import { getDepartureCities } from 'Utils/faceting/facetingUtils';
import createReducer from 'Store/utils/createReducer';
import { FACETING_SEARCH_REQUEST } from 'Store/faceting/constants';

const initialState = {
  departureCities: [],
};

const facetingTripInformation = createReducer(initialState, {
  [resolve(FACETING_SEARCH_REQUEST)](
    state: ReduxState,
    action: FacetingSearchRequestResolvedAction,
  ): ReduxState {
    return {
      departureCities: getDepartureCities(get(action, 'payload.catalogs', [])),
    };
  },
});

export default facetingTripInformation;
